module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10060.579b193b.jpg";